<template>
  <div class="callout" style="border: 0px;">
    <div class="text-primary pt-5">
      <template v-for="(dir, i) in path">
        <i class="fas fa-angle-right text-secondary" v-if="i > 0" :key="i"> </i>
        {{ dir }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "DirPath",
  props: {
    path: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.callout {
  padding-left: 0;
}
</style>
